import React from 'react';

import { FooterOverlay } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <div className="footer__copyright">
      <button type="button" className="custom__button"><a href="https://docs.google.com/forms/d/e/1FAIpQLScoBXq_9oalh3UZJLbqx0ETHIx9ev7oEyIsrCOIx4_YBjAo6Q/viewform?usp=sf_link"><div className="p__opensans">ORDER IT NOW</div></a></button>
    </div>
    <div className="app__footer-links">
      <div className="app__footer-links_logo">
        <img src={images.spoon} className="spoon__img" style={{ marginTop: 15 }} />
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">© 2022 Imperial College Singapore Society. All Rights Reserved.</p>
    </div>

  </div>
);

export default Footer;
